// extracted by mini-css-extract-plugin
export default {"header":"Header_header__yRlN3","main-image":"Header_main-image__ZNamw"};